export const centerElementOnCanvas = (width, height, scaleX, scaleY, maxCanvasWidth, maxCanvasHeight) => {
  return {
    x: maxCanvasWidth - (width * scaleX) / 2,
    y: maxCanvasHeight - (height * scaleY) / 2
  };
};

export const fitElementToCanvas = (width, height, canvasSize) => {
  const maxCanvasHeight = canvasSize.height / 2;
  const maxCanvasWidth = canvasSize.width / 2;

  const ratioW = maxCanvasWidth / width;
  const ratioH = maxCanvasHeight / height;
  if (ratioW <= ratioH) {
    return {
      scaleX: ratioW,
      scaleY: ratioW,
      ...centerElementOnCanvas(width, height, ratioW, ratioW, maxCanvasWidth, maxCanvasHeight)
    };
  }
  return {
    scaleX: ratioH,
    scaleY: ratioH,
    ...centerElementOnCanvas(width, height, ratioH, ratioH, maxCanvasWidth, maxCanvasHeight)
  };
};
